import React from "react";
import { Check, Pencil, Save } from "lucide-react";
import PropTypes from "prop-types";


const EditSaveButton = ({
    isSaving,
    isAutoSaving,
    hasUnsavedChanges,
    isEditing,
    onToggle,
    t,
}) => {
    if (isSaving) {
        return (
            <div className="flex items-center gap-2 text-blue-600 dark:text-blue-400">
                <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin" />
                <span className="text-sm font-medium">Saving...</span>
            </div>
        );
    }

    if (isAutoSaving && hasUnsavedChanges) {
        return (
            <div className="flex items-center gap-2 text-emerald-600 dark:text-emerald-400 animate-pulse">
                <Save size={16} className="animate-bounce" />
                <span className="text-sm font-medium">Auto-saving...</span>
            </div>
        );
    }

    if (hasUnsavedChanges && isEditing) {
        return (
            <div className="flex items-center gap-2">
                <div className="flex items-center gap-1 text-amber-600 dark:text-amber-400">
                    <div className="w-2 h-2 bg-amber-500 rounded-full animate-pulse" />
                    <span className="text-sm font-medium">
                        {t("verifyDataModel.unsavedChages")}
                    </span>
                </div>
                <button
                    onClick={onToggle}
                    disabled={isSaving}
                    className="text-white bg-[#0F2FA0] hover:bg-[#007E86] px-3 py-1 rounded-full flex items-center gap-1 transition-all duration-200 disabled:opacity-50 transform hover:scale-105"
                >
                    <Check size={16} strokeWidth={2.5} />
                    <span className="text-sm font-medium">{t("save")}</span>
                </button>
            </div>
        );
    }

    return (
        <button
            onClick={onToggle}
            disabled={isSaving}
            className="text-white bg-[#0F2FA0] hover:bg-[#007E86] px-3 py-1 rounded-full flex items-center gap-1 transition-all duration-200 disabled:opacity-50 transform hover:scale-105"
        >
            {isEditing ? (
                <>
                    <Check size={16} strokeWidth={2.5} />
                    <span className="text-sm font-medium">{t("save")}</span>
                </>
            ) : (
                <>
                    <Pencil size={16} strokeWidth={2.5} />
                    <span className="text-sm font-medium">{t("edit")}</span>
                </>
            )}
        </button>
    );
};

EditSaveButton.propTypes = {
    isSaving: PropTypes.bool,
    isAutoSaving: PropTypes.bool,
    hasUnsavedChanges: PropTypes.bool,
    isEditing: PropTypes.bool,
    onToggle: PropTypes.func,
    t: PropTypes.func,
};
export default EditSaveButton;